import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { UserGroupIndexComponent } from './crud-index/crud-index.component';
import { UserGroupCESComponent } from './crud-ces/crud-ces.component';
import { TypeCesEnum } from 'src/app/domain/registration/enums/type-ces.enum';

const routes: Routes = [
  {
    path: '',
    component: UserGroupIndexComponent,
  },
  {
    path: 'new',
    component: UserGroupCESComponent,
    data: { type: TypeCesEnum.NEW },
  },
  {
    path: 'show/:id',
    component: UserGroupCESComponent,
    data: { type: TypeCesEnum.SHOW },
  },
  {
    path: 'edit/:id',
    component: UserGroupCESComponent,
    data: { type: TypeCesEnum.EDIT },
  },
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule],
})
export class UserGroupsRoutingModule {}
